<template>
  <div
    v-loading="loading"
    v-infinite-scroll="load"
    :infinite-scroll-disabled="disabled"
  >
    <div
      v-if="!loading && $_.isEmpty(jobs)"
      class="text-center p-4"
    >
      <FontAwesomeIcon
        :icon="['fal', 'microchip']"
        size="4x"
      />
      <br>
      <p>No notifications found</p>
    </div>

    <div
      v-for="(item, index) in messages"
      :key="item.id || item.created_at || index"
      :class="['notice-item', `notice-${normalizeType(item.type)}`]"
    >
      <div class="notice-meta">
        <el-tag
          size="mini"
          :type="tagType(item.type)"
          effect="dark"
        >
          {{ typeLabel(item.type) }}
        </el-tag>

        <span class="notice-time">
          {{ formatTime(item.created_at) }}
        </span>
      </div>

      <h4 class="notice-title">
        {{ item.title || 'Notification' }}
      </h4>
      <p class="notice-message">
        {{ item.message || 'No message content provided.' }}
      </p>

      <div
        v-if="hasAction(item)"
        class="notice-actions"
      >
        <el-button
          type="text"
          size="mini"
          @click="runAction(item)"
        >
          Open
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      count: 10,
      loading: false,
      events: []
    }
  },
  computed: {
    messages () {
      return this.$store.getters['cache/events']('pusher') || []
    },
    noMore () {
      return this.count >= 20
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    normalizeType (type) {
      const value = (type || 'info').toLowerCase()
      if (['success', 'warning', 'danger', 'error', 'info'].includes(value)) {
        return value === 'danger' ? 'error' : value
      }
      return 'info'
    },
    tagType (type) {
      const value = this.normalizeType(type)
      return value === 'error' ? 'danger' : value
    },
    typeLabel (type) {
      const value = this.normalizeType(type)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    clearMessages () {
      this.$pusher.clearMessages()
    },
    formatTime (value) {
      if (!value) return 'Now'
      const date = this.$moment(value)
      return date.isValid() ? date.fromNow() : 'Now'
    },
    hasAction (item) {
      return !!this.$_.get(item, 'action.type') && !!this.$_.get(item, 'action.value')
    },
    runAction (item) {
      const action = this.$_.get(item, 'action')
      if (!action) return

      if (action.type === 'route') {
        this.$router.push(action.value).catch(() => {})
      }
    },
    load () {
      this.loading = true
      this
        .$sdk
        .feedevent
        .list(request => {
          request.order = 'created_at:desc'
        })
        .then(res => { this.events = res })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.notification-panel {
  width: 340px;
  max-height: 420px;
  background: linear-gradient(180deg, #fcfcfd 0%, #f5f7fa 100%);
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(26, 44, 80, 0.08);
  overflow: hidden;
}

.panel-header {
  padding: 12px 14px;
  border-bottom: 1px solid #e9edf3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.heading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #223047;
}

.panel-body {
  overflow-y: auto;
  max-height: 360px;
  padding: 10px;
}

.notice-item {
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border-left: 4px solid #8797ad;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(31, 50, 81, 0.08);
}

.notice-info {
  border-left-color: #409eff;
}

.notice-success {
  border-left-color: #67c23a;
}

.notice-warning {
  border-left-color: #e6a23c;
}

.notice-error {
  border-left-color: #f56c6c;
}

.notice-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.notice-time {
  font-size: 11px;
  color: #8a97a8;
}

.notice-title {
  margin: 0;
  font-size: 13px;
  color: #1f2f47;
}

.notice-message {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #50607a;
}

.notice-actions {
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
}

.panel-loading {
  padding: 10px;
  text-align: center;
  font-size: 12px;
  color: #7f8ca2;
}
</style>
